"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUniqueId;

var _react = require("react");

var count = 0;

/**
 * @param {?string} prefix
 * @return {string} An id string that's unique for that prefix
 */
function useUniqueId(prefix) {
  var idRef = (0, _react.useRef)();

  if (!idRef.current) {
    count += 1;
    idRef.current = "" + prefix + count;
  }

  return idRef.current;
}

module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.106/js/hooks/useUniqueId.js
// module id = 182
// module chunks = 0